module.exports = __webpack_public_path__ + "media/images/hero-datafinder-cfaed26e661346cbd99a31b6a4ec5ee7.svg";